const distances = {
  pageMarginBig: 4,
  pageMarginSmall: 2,
  gapSmall: 2,
  gapBig: 4,
  shadow: 0.4,
  shadowSmall: 0.15,
  shadowSmallest: 0.1,
};

export default distances;
